// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2--_2","checkbox":"styles_checkbox__3iTrV","selectedButton":"styles_selectedButton__e4RAA","animate":"styles_animate__2WA2w","flash":"styles_flash__2w-yd"};